export const TEST_ID = 'logServiceFooter';

export const CANCEL_BUTTON_TEST_ID = 'logServiceFooterCancelButton';

export const SAVE_BUTTON_TEST_ID = 'logServiceFooterSaveButton';
